<template>
  <div id="my">
    <header class="myhead">
      <div class="headwrap">
        <div class="user"><div class="img"><img :src=headimgurl alt="avatar"></div><span class="name">{{nickname}}</span></div>
        <div class="login_box" v-if="!loginStatus">
          <router-link class="btn btn_login" to="/login"><span>未登录</span></router-link>
        </div>
      </div>
    </header>
    <div class="mycell">
      <van-cell-group>
        <van-cell @click="bill()" title="停车记录" is-link />
        <!-- <van-cell @click="coupon()" title="优惠券" is-link  /> -->
        <van-cell title="套餐充值" is-link to="/searchCombo" />
        <!-- <van-cell @click="goSearch()" title="寻车" is-link /> -->
        <van-cell title="停车锁车" is-link to="/lockIndex" v-if="loginStatus" />
        <van-cell title="电子发票" is-link to="/recordType" />

        <van-cell title="密码修改" is-link to="/forgetPassword" v-if="loginStatus" />
        <van-cell title="信息变更" is-link to="/updateAccountInfo" v-if="loginStatus" />
        <van-cell title="车辆管理" is-link to="/manageCars" v-if="loginStatus" />
        <van-cell title="无牌车月卡申请" is-link to="/noCarParkingcomm" v-if="loginStatus" />
      </van-cell-group>
      <div class="logout_box" style="padding:15px 20px;" v-if="loginStatus">
        <van-button size="large" type="danger" @click='logout'>退出登录</van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import {Cell, CellGroup } from 'vant';
  import {DETAIL as API} from "@/assets/api";
  export default {

    data() {
      return {
        headimgurl: require("../../../static/images/headimg.png"),
        nickname: "",
        isLZJ: false,
      }
    },
    computed: {
      loginStatus(){
        return this.$store.state.loginStatus
      },
    },
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup
    },
    methods: {
      goSearch() { //跳转至寻车页面
        this.$router.push({
          name: "searchCar"
        })
      },
      bill() {
        this.$router.push({
          name: "accountrecorder"
        })
      },
      invoice() {
        this.$dialog.alert({
          title: '提示',
          message: '敬请期待'
        })
      },
      coupon() {
        this.$dialog.alert({
          title: '提示',
          message: '敬请期待'
        })
      },
      logout(){
        this.commonUtil.logout();  // 暂时只是本地清除了数据
        this.commonUtil.setCookie('isUserLogOut', true, 3650)
        this.$router.replace({name: 'my'});
      },
      renderUser(){
        let headimgurl = this.commonUtil.getCookie("headimgurl");
        let nickname = this.commonUtil.getCookie("nickname");
        if (!this.commonUtil.isEmpty(headimgurl) || !this.commonUtil.isEmpty(nickname)) {
          this.headimgurl = headimgurl
          this.nickname = nickname
        }
      },
      automaticLogin(){
        // 用户主动退出，不自动登录
        let isUserLogOut = this.commonUtil.getCookie('isUserLogOut')
        if(isUserLogOut) return
        let loginStatus = this.$store.state.loginStatus
        if(!loginStatus){
          let browserType = this.$store.state.browserType;
          if(browserType == 'other') {this.$toast('请用微信或者支付宝打开!');return}

          let originalId = this.$store.state.originalId;
          let req = {
              originalId: originalId,
              browserType: browserType
          }
          $.ajax({
            url: API.LOGIN,
            type:'POST', 
            async:false, //true或false,是否异步
            data: req,
            timeout:5000, //超时时间
            dataType:'json', //返回的数据格式
            success:(res)=>{
              if (res.code == 0) {
                  this.commonUtil.delCookie('isUserLogOut')
                  const expriyTimeStamp = new Date().getTime() + this.$store.state.indate*24*60*60*1000;
                  this.$store.commit('setExpriyTimeStamp',expriyTimeStamp);
                  if (res.data.length) { // 保存车辆信息
                      this.commonUtil.updateUserInfo(res.data[0].phonenumber);//登录成功保存用户信息
                      let cars = [];
                      if(res.data[0].cars) cars = res.data[0].cars;
                      this.$store.commit('getBindCars',cars);
                  }
              }else{
                this.$toast('自动登录失败，请重新登录')
              }
            },
            error:function(xhr,textStatus){
                alert('请求失败'+textStatus);
            }
          
          });
        }

      },
    },
    created() {
      this.renderUser();
      this.automaticLogin();
    },
    watch: {
      
    },
  }

</script>

<style>
  #my{
    height: 90%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  #my .van-cell__title,
  .van-cell__value {
    text-align: left;
  }

  #my .van-cell {
    margin-top: 5px;
    padding: 13px 15px;
  }

  #my .van-cell:not(:last-child)::after {
    border: none;
  }

  #my .van-cell-group {
    background: none;
  }

  #my .myhead {
    display: flex;
    padding: 24px 15px;
    background: white;
  }
  #my .myhead .headwrap{
    width: 100%;
    height: 100%;
    position: relative;
  }
  #my .myhead .user{
    font-size: 0;
    text-align: left;
  }
  #my .myhead .user .img{
    display: inline-block;
    vertical-align: middle;
    box-shadow: 1px 0px 16px #cecccc;
    border-radius: 100%;
    padding: 6px;
    width: 47px;
    height: 47px;
  }
  #my .myhead .user .img img{
    width: 100%;
    border-radius: 100%;
  }
  #my .myhead .user .name{
    vertical-align: middle;
    line-height: 60px;
    padding-left: 8px;
    font-size: 16px;
  }
  #my .myhead .login_box{
    position: absolute;
    right: 0;
    top: 0;
    text-align: right;
  }

  #my .myhead .login_box .btn{
    line-height: 60px;
    font-size: 16px;
    color: #2c3e50;
    padding-right: 5px;
  }

  #my .myhead .login_box .btn:after{
    content: "";
    display: inline-block;
    margin-left: 5px;
    width: 8px;
    height: 8px;
    border-top: 1px solid #a6a9c4;
    border-right: 1px solid #a6a9c4;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

</style>



// WEBPACK FOOTER //
// src/components/my/my.vue